const ExploreAnalyticsEvent = {
  GroupClassDetailsOpenedFromDeepLink:
    "Group Class Details Opened from Deep Link",
  SearchGroupsOpenedFromDeepLink: "Search Groups Opened from Deep Link",
  VideoContentOpenedFromDeepLink: "Video Content Opened from Deep Link",
} as const;

const ExploreAnalyticsSources = {
  ExploreScreen: "Explore Screen",
} as const;

export { ExploreAnalyticsEvent, ExploreAnalyticsSources };
